import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  CircularProgress,
  Divider,
  Paper,
} from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import axiosInstance from '../services/axiosInstance';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [loading, setLoading] = useState(true);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [bookingDetails, setBookingDetails] = useState(null);

  useEffect(() => {
    const fetchSessionDetails = async () => {
      try {
        const response = await axiosInstance.get(
          `/users/booking/checkSession/${sessionId}`
        );
        if (response.success) {
          setPaymentDetails(response.session);
          setBookingDetails(response.booking);
        }
      } catch (error) {
        console.error('Error al obtener los detalles de la sesión:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSessionDetails();
  }, [sessionId]);

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          backgroundColor: '#f9f9f9',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '100vh',
        padding: 4,
        backgroundColor: '#f9f9f9',
      }}
    >
      {/* Logo */}
      <Box
        component="img"
        src="logo.png"
        alt="Logo"
        sx={{
          width: 100,
          height: 'auto',
          marginBottom: 3,
        }}
      />

      {/* Título */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: 600,
          color: '#333',
          marginBottom: 2,
        }}
      >
        Pago Completado
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: '#666',
          marginBottom: 4,
          maxWidth: 600,
          textAlign: 'center',
        }}
      >
        Gracias por tu pago. Hemos procesado tu reserva con éxito. Los detalles
        de tu reserva están a continuación.
      </Typography>

      {/* Contenedor de Detalles */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          maxWidth: 600,
          width: '100%',
        }}
      >
        {/* Detalles del Pago */}
        <Paper
          elevation={0}
          sx={{
            padding: 3,
            borderRadius: 2,
            border: '1px solid #e0e0e0',
            backgroundColor: '#fff',
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 500,
              marginBottom: 2,
              color: '#333',
            }}
          >
            Detalles del Pago
          </Typography>
          <Divider sx={{ marginBottom: 2 }} />
          <Typography variant="body2" sx={{ color: '#555', marginBottom: 1 }}>
            <strong>Nombre:</strong>{' '}
            {paymentDetails?.customer_details?.name || 'N/A'}
          </Typography>
          <Typography variant="body2" sx={{ color: '#555', marginBottom: 1 }}>
            <strong>Email:</strong>{' '}
            {paymentDetails?.customer_details?.email || 'N/A'}
          </Typography>
          <Typography variant="body2" sx={{ color: '#555' }}>
            <strong>Total Pagado:</strong> {paymentDetails?.amount_total / 100}{' '}
            €
          </Typography>
        </Paper>

        {/* Detalles de la Reserva */}
        {bookingDetails && (
          <Paper
            elevation={0}
            sx={{
              padding: 3,
              borderRadius: 2,
              border: '1px solid #e0e0e0',
              backgroundColor: '#fff',
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 500,
                marginBottom: 2,
                color: '#333',
              }}
            >
              Detalles de la Reserva
            </Typography>
            <Divider sx={{ marginBottom: 2 }} />
            <Typography variant="body2" sx={{ color: '#555', marginBottom: 1 }}>
              <strong>Fecha:</strong>{' '}
              {new Date(bookingDetails.dateBooked).toLocaleDateString('es-ES', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
              })}
            </Typography>
            <Typography variant="body2" sx={{ color: '#555', marginBottom: 1 }}>
              <strong>Hora:</strong> {bookingDetails.timeBooked}
            </Typography>
            <Typography variant="body2" sx={{ color: '#555', marginBottom: 2 }}>
              <strong>Pista:</strong> {bookingDetails.courtBooked}
            </Typography>
            <Typography variant="body2" sx={{ color: '#555', marginBottom: 1 }}>
              <strong>Jugadores:</strong>
            </Typography>
            <Box>
              {bookingDetails.players.map((player, index) => (
                <Typography
                  key={index}
                  variant="body2"
                  sx={{ color: '#666', marginBottom: 1 }}
                >
                  -{' '}
                  {player.isMember
                    ? player.nonMemberName ||
                      `${player.memberId?.name || ''} ${player.memberId?.surname || ''}`.trim() ||
                      'Jugador Socio'
                    : `${player.nonMemberName || ''} ${player.nonMemberSurname || ''}`.trim() ||
                      player.nonMemberEmail ||
                      'N/A'}
                </Typography>
              ))}
            </Box>
          </Paper>
        )}
      </Box>

      {/* Mensaje Final */}
      <Typography
        variant="body2"
        sx={{
          marginTop: 4,
          color: '#777',
          textAlign: 'center',
          maxWidth: 500,
        }}
      >
        Nos encanta que formes parte de nuestro club. ¡Disfruta tu reserva y que
        tengas un gran partido! 🎾
      </Typography>
    </Box>
  );
};

export default PaymentSuccess;
